import { ButtonERP } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getCtasBancariasContactoById } from "api/Contacto.service"
import {
  useCuentaContableEmpresaComisionAperturaPrestamoConcedido,
  useCuentaContableEmpresaComisionAperturaPrestamoRecibido,
  useCuentaContableEmpresaInteresPrestamoConcedido,
  useCuentaContableEmpresaInteresPrestamoRecibido,
  useCuentaContableEmpresaPrestamoConcedido,
  useCuentaContableEmpresaPrestamoRecibido,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaInteresPrestamoConcedido,
  useCuentaContableCuentaInteresPrestamoRecibido,
  useCuentaContableCuentaPrestamoConcedido,
  useCuentaContableCuentaPrestamoRecibido,
} from "api/CuentaContable_Cuenta.hook"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import classNames from "classnames"
import CustomButton from "common/components/Button/Button"
import ButtonsToggle from "common/components/ButtonsToggle"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import CamposPersonalizadoBoard from "common/components/FormikFields/CamposPersonalizadosBoard"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputDate from "common/components/FormikFields/FormikInputDate"
import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import FormikTextArea from "common/components/FormikFields/FormikTextArea"
import Modal from "common/components/Modal/Modal"
import Switch from "common/components/Switch/index"
import {
  CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE,
  ESTADO_TIPO_COMISION,
  ESTADO_TIPO_PRESTAMOS,
  PRESTAMOS_TYPE,
} from "common/utils/constants"
import { CreateEditEntidadModalProps } from "features/Contactos/components/CuentasBancarias"
import { ModalAccountContactCuentaBancaria } from "features/Contactos/components/CuentasBancarias/Components/ModalAccountContactCuentaBancaria/ModalAccountContactCuentaBancaria"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import { isNumber } from "lodash"
import { nanoid } from "nanoid"
import { Button } from "primereact/button"
import { DropdownChangeParams } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { getToggleButtons } from "../../constants"
import {
  PERIODO_AMORTIZACION,
  TIPO_PERIODO_AMORTIZACION,
  getTypeValueComision,
} from "../../pages/PrestamoDetail/constants"
import NewComisionBoard from "../NewComisionBoard"
import ContactoSelect from "./components/ContactoSelect"
import {
  PERIODO_AMORTIZACION_OPTIONS,
  SELECTOR_TIPO,
  TIPOS_AMORTIZACION_OPTIONS,
  getBooleanIndefinido,
  getDropdownAccounts,
  handleChangeValueMessage,
  resetDefaultFormValues,
  setInititalAccountValues,
} from "./constants"
import "./styles.scss"

const PrestamoForm = ({
  hideModal,
  handleChange,
  setFieldValue,
  values,
  handleSubmit,
  handleBlur,
  isEditView,
  data,
  errors,
  touched,
  resetForm,
  deuda,
  dataPrestamo,
  hideModalPrincipal,
  tipoPrestamo,
  newPrestamo,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()

  const [createOrEditModal, setCreateOrEditModal] =
    useState<CreateEditEntidadModalProps>({
      show: false,
      isEdit: undefined,
    })

  const onHideCreateOrEditModal = () =>
    setCreateOrEditModal({
      show: false,
      isEdit: undefined,
    })

  const { getCuentaContablePorDefecto } = useCuentasContables()

  const {
    cuentasContablesEmpresas: cuentasContablesComisionAperturaPrestamoRecibido,
  } = useCuentaContableEmpresaComisionAperturaPrestamoRecibido()

  const {
    cuentasContablesEmpresas: cuentasContablesComisionAperturaPrestamoConcedido,
  } = useCuentaContableEmpresaComisionAperturaPrestamoConcedido()

  const { cuentasContablesEmpresas: cuentasContablesPrestamoConcedidoBase } =
    useCuentaContableCuentaPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasContablesPrestamoConcedido,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasPrestamoConcedido,
  } = useCuentaContableEmpresaPrestamoConcedido()

  const { cuentasContablesEmpresas: cuentasContablesPrestamoRecibidoBase } =
    useCuentaContableCuentaPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasContablesPrestamoRecibido,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasPrestamoRecibido,
  } = useCuentaContableEmpresaPrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      cuentasContablesInteresesPrestamoConcedidoComprasBase,
  } = useCuentaContableCuentaInteresPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasContablesInteresPrestamoConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasPrestamoInteresConcedido,
  } = useCuentaContableEmpresaInteresPrestamoConcedido()

  const {
    cuentasContablesEmpresas:
      cuentasContablesInteresesPrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaInteresPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasContablesInteresPrestamoRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasPrestamoInteresRecibido,
  } = useCuentaContableEmpresaInteresPrestamoRecibido()

  const [cuentasBancarias, setCuentasBancarias] = useState([])

  const [selectedAccount, setSelectedAccount] = useState()
  const [showModalConfirmAmortizacion, setShowModalConfirmAmortizacion] =
    useState(false)
  const [tabSelected, setTabSelected] = useState(
    tipoPrestamo || ESTADO_TIPO_PRESTAMOS(t)[values?.tipoPrestamo]?.value
  )
  const [activeSwitch, setActiveSwitch] = useState(getBooleanIndefinido(values))
  const [changeImporte, setChangeImporte] = useState(0)
  const [typeChange, setTypeChange] = useState("")

  const handleResetForm = useCallback(
    (tabValue: $TSMigrationFixMe) => {
      if (isEditView) {
        resetDefaultFormValues(setFieldValue)
      } else {
        resetForm()
        setFieldValue("camposPersonalizados", [])
        setFieldValue("comisiones", [])
        setFieldValue("descripcion", "")
        setFieldValue("cuentaContableEmpresaId", "")
        setFieldValue("tipoPrestamo", tabValue)
      }
    },
    [isEditView, resetForm, setFieldValue]
  )

  const handleTab = useCallback(
    (tabValue: $TSMigrationFixMe) => {
      setTabSelected(tabValue)
      setFieldValue("tipoPrestamo", tabValue)
      handleResetForm(tabValue)
    },
    [handleResetForm, setFieldValue]
  )

  const onRenderButtonsOptions = useMemo(() => {
    // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
    return getToggleButtons(handleTab, t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleTab])

  const transformDataComisiones = values?.comisiones?.map(
    ({
      cuentaContableEmpresaId,
      importe,
      tipoComision,
      elementId,
      key,
      originalObject,
      label,
      value,
      extraValue,
    }: $TSMigrationFixMe) => {
      const cuentaContable = (
        tabSelected === PRESTAMOS_TYPE.CONCEDIDO
          ? cuentasContablesComisionAperturaPrestamoConcedido
          : cuentasContablesComisionAperturaPrestamoRecibido
      )?.filter((cuenta) => cuenta.id === cuentaContableEmpresaId)[0]
      return {
        label: ESTADO_TIPO_COMISION(t)[tipoComision]?.fullText || label,
        value: importe?.tipoImporte
          ? getTypeValueComision(importe?.tipoImporte, importe?.valor)
          : value,
        extraValue: cuentaContable?.nombre || extraValue,
        elementId: elementId || nanoid(),
        key: key || nanoid(),
        originalObject: originalObject || {
          cuentaContableEmpresaId,
          importe,
          tipoComision,
        },
      }
    }
  )

  useEffect(() => {
    if (data?.empresaId && cuentasBancarias?.length) {
      setInititalAccountValues(
        data,
        cuentasBancarias,
        setSelectedAccount,
        setFieldValue
      )
    }
  }, [
    cuentasBancarias,
    data,
    data?.cuentaBancariaId,
    data?.empresaId,
    setFieldValue,
  ])

  const handleAmortizacionSwitch = () => {
    setActiveSwitch(!activeSwitch)
    if (!activeSwitch) {
      setFieldValue("duracion", null)
    } else {
      setFieldValue("importeAmortizacion", null)
    }
  }

  const handleSelectCtaContable = (newCuentaContable: DropdownChangeParams) =>
    setFieldValue(SELECTOR_TIPO[1], newCuentaContable.value)

  const handleSelectCtaContableInteres = (
    newCuentaContable: DropdownChangeParams
  ) => setFieldValue(SELECTOR_TIPO[2], newCuentaContable.value)

  const handleInteresChange = (e: $TSMigrationFixMe) => {
    if (e.value <= 0) {
      setFieldValue(SELECTOR_TIPO[2], null)
    }
    setFieldValue("interes.importe", e.value)
  }

  const handleSelectContacto = async (value: $TSMigrationFixMe) => {
    setFieldValue("empresaId", value.empresaContactoId)
    setFieldValue("empresaContactoId", value.id)
    const resp = await getCtasBancariasContactoById(value.empresaContactoId)
    // @ts-expect-error TS(2345): Argument of type 'CuentaBancariaContactoReadingDto...
    setCuentasBancarias(resp)
  }

  const handleBankAccount = ({ value }: $TSMigrationFixMe) => {
    const account = {
      cuentaIdExterno: value.id,
      iban: value.iban,
      bic: value.bic,
      entidadBancariaId: value.id,
    }
    setFieldValue("cuentaBancaria", account)
    setSelectedAccount(value)
  }

  const handleShowModalCtaBancaria = () => {
    setCreateOrEditModal({
      show: true,
      isEdit: undefined,
    })
  }

  const handleCreateCtaBancaria = async () => {
    const cuentasBancaraisArray = await getCtasBancariasContactoById(
      values.empresaId
    )
    // @ts-expect-error TS(2345): Argument of type 'CuentaBancariaContactoReadingDto...
    setCuentasBancarias(cuentasBancaraisArray)
  }

  useEffect(() => {
    async function fetchCuentasBancarias() {
      if (values.empresaId) {
        const data = await getCtasBancariasContactoById(values.empresaId)
        // @ts-expect-error TS(2345): Argument of type 'CuentaBancariaContactoReadingDto...
        setCuentasBancarias(data ?? [])
      }
    }

    fetchCuentasBancarias()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.empresaId])

  useEffect(() => {
    if (isNumber(values?.importe) && isNumber(data?.importe)) {
      setChangeImporte(values?.importe - data?.importe)
    }
  }, [values, data])

  const onSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    const sinAsientos = dataPrestamo?.every(
      (lineas: $TSMigrationFixMe) => lineas.asientoContable === null
    )
    const value = `${deuda > 0 ? "CON" : "SIN"}_ADEUDO`
    if (sinAsientos) {
      return handleSubmit()
    }
    return changeImporte > 0
      ? (setShowModalConfirmAmortizacion(true), setTypeChange(value))
      : handleSubmit()
  }

  const onConfirmSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    handleSubmit()
    setShowModalConfirmAmortizacion(false)
  }

  const onCancelConfirmAmort = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    setShowModalConfirmAmortizacion(false)
    hideModalPrincipal()
  }

  const setInitialCuentasContables = () => {
    if (newPrestamo) {
      setFieldValue(
        SELECTOR_TIPO[1],
        getCuentaContablePorDefecto(
          tabSelected === 2
            ? CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_RECIBIDO
            : CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_CONCEDIDO
        ) || ""
      )
      setFieldValue(
        SELECTOR_TIPO[2],
        getCuentaContablePorDefecto(
          tabSelected === 2
            ? CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_RECIBIDO
            : CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_CONCEDIDO
        ) || ""
      )
    }
  }

  useEffect(() => {
    setInitialCuentasContables()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabSelected])

  useEffect(() => {
    setFieldValue("isIndefinido", activeSwitch)
    return () => {
      setCuentasBancarias([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSwitch])

  return (
    <form onSubmit={onSubmit}>
      <div className='mt-3 mb-3 input-group_container'>
        <div className='input_box'>
          <label htmlFor='concepto'>{t("prestamos.form.conceptoLabel")}</label>
          <FormikInputText
            id='concepto'
            name='concepto'
            type='text'
            onChange={handleChange}
            value={values.concepto ? "" : values.concepto}
          />
        </div>
        <div className='input_box w-100 d-flex '>
          <label htmlFor='concepto'>{t("prestamos.form.typeLabel")}</label>
          <ButtonsToggle
            headerGroupItems={onRenderButtonsOptions}
            className='w-100 '
            initialValue={
              onRenderButtonsOptions.filter(
                (option) => option.id === tabSelected
              )[0]
            }
          />
        </div>
      </div>
      <div className='mt-3 mb-3 input-group_container'>
        <ContactoSelect
          title={t("prestamos.form.contactLabel")}
          className='contacto_dropdown'
          isComprador={tabSelected === PRESTAMOS_TYPE.RECIBIDO}
          getClienteProveedor={handleSelectContacto}
          errors={touched?.empresaId && errors?.empresaId}
          onBlur={handleBlur}
          values={values}
          razonSocial={data?.razonSocial}
        />

        <div className='input_box'>
          <label htmlFor='fecha'>{t("prestamos.form.dateLabel")}</label>
          <FormikInputDate
            id='fecha'
            name='fecha'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.fecha}
          />
        </div>
      </div>
      <div className='mb-3 select_container'>
        <label htmlFor='tipoDocumento'>
          {t("prestamos.form.accountLabel")}
        </label>
        <FormikDropdown
          options={getDropdownAccounts(cuentasBancarias)}
          value={selectedAccount}
          onChange={(value: $TSMigrationFixMe) => handleBankAccount(value)}
          placeholder={t("prestamos.form.placeholderAccount")}
          emptyFilterMessage={t("prestamos.form.emptyMsg")}
          emptyMessage={t("prestamos.form.emptyMsg")}
          fluid
          id='cuentaBancaria.cuentaIdExterno'
          name='cuentaBancaria.cuentaIdExterno'
          onBlur={handleBlur}
        />
        <span
          onClick={() => values.empresaId && handleShowModalCtaBancaria()}
          className='text-gedesco link-cancel añadir-cuenta_container mt-3'
        >
          <FontAwesomeIcon icon={["fal", "plus"]} />{" "}
          {t("prestamos.form.addAccountLabel")}
        </span>
      </div>
      <div className='mb-3 input-group_container'>
        <div className='input_box'>
          <label htmlFor='descripcion'>
            {t("prestamos.form.descriptionLabel")}
          </label>
          <FormikTextArea
            id='descripcion'
            name='descripcion'
            value={values.descripcion}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete='off'
          />
        </div>
      </div>
      <div className='mb-3 input-main_content'>
        <h6>{t("prestamos.form.dataEconomic")}</h6>
        <div className='mt-3 mb-2 input-group_container'>
          <div className='input_box'>
            <label htmlFor='tipoDocumento'>
              {t("prestamos.form.importLabel")}
            </label>
            <FormikInputNumber
              id='importe'
              name='importe'
              onBlur={handleBlur}
              minFractionDigits={2}
            />
          </div>
          <div className='mb-3 input_box'>
            <label htmlFor='periodoAmortizacion'>
              {t("prestamos.form.whitteOffPeriodeLabel")}
            </label>
            <FormikDropdown
              options={PERIODO_AMORTIZACION_OPTIONS(t)}
              value={values.periodoAmortizacion}
              onChange={(value: $TSMigrationFixMe) => handleChange(value)}
              placeholder={t("prestamos.form.placeholderAccount")}
              emptyFilterMessage={t("prestamos.form.emptyMsg")}
              emptyMessage={t("prestamos.form.emptyMsg")}
              fluid
              id='periodoAmortizacion'
              name='periodoAmortizacion'
              onBlur={handleBlur}
            />
          </div>
        </div>

        <div className='mb-2 input-group_container'>
          <div
            className={classNames("input_box", {
              disabled: activeSwitch,
            })}
          >
            <div className='switch-container'>
              <label htmlFor='tipoDocumento'>
                {t("prestamos.form.durationLabel")}
              </label>
              <div className='switch-container'>
                <label>{t("prestamos.form.indefinidaLabel")}</label>
                <Switch
                  handleChange={handleAmortizacionSwitch}
                  checked={activeSwitch}
                />
              </div>
            </div>
            <FormikInputNumber
              id='duracion'
              name='duracion'
              onBlur={handleBlur}
              disabled={activeSwitch}
            />
          </div>
          <div className='input_box'>
            <label htmlFor='interes'>{t("prestamos.form.intAnualLabel")}</label>
            <span className='p-input-icon-left p-input-percentage_container w-100'>
              <i className='pi pi-percentage' />
              <FormikInputNumber
                id='interes.importe'
                name='interes.importe'
                className='p-input-percentage w-100'
                onBlur={handleBlur}
                isActiveErrorMsg={false}
                onChange={handleInteresChange}
                minFractionDigits={1}
              />
            </span>
            {touched?.interes?.importe && errors?.interes?.importe && (
              <small className='p-error p-d-block'>
                {errors.interes?.importe}
              </small>
            )}
          </div>
        </div>

        <div className='mb-3 input-group_container'>
          <div
            className={classNames("cuentas-contables_select-container mb-3", {
              disabled: values?.interes?.importe <= 0,
            })}
          >
            <label>{t("prestamos.form.cuentaConIntLabel")}</label>
            {!(tabSelected === PRESTAMOS_TYPE.CONCEDIDO
              ? cuentasContablesInteresPrestamoConcedido?.length
              : cuentasContablesInteresPrestamoRecibido?.length) ||
            values.interes?.importe <= 0 ||
            !values.interes?.importe ? (
              <span className='p-input-icon-left w-100'>
                <InputText disabled />
              </span>
            ) : (
              <DropdownCuentasContablesConModal
                cuentasContablesOptions={
                  tabSelected === PRESTAMOS_TYPE.CONCEDIDO
                    ? cuentasContablesInteresPrestamoConcedido
                    : cuentasContablesInteresPrestamoRecibido
                }
                disabled={values.interes?.importe <= 0}
                dropdownValue={values?.interes?.cuentaContableEmpresaId}
                onChange={handleSelectCtaContableInteres}
                listaDeCuentasBase={
                  tabSelected === PRESTAMOS_TYPE.CONCEDIDO
                    ? cuentasContablesInteresesPrestamoConcedidoComprasBase
                    : cuentasContablesInteresesPrestamoRecibidoComprasBase
                }
                refreshFetchData={
                  tabSelected === PRESTAMOS_TYPE.CONCEDIDO
                    ? refresListaDeCuentasPrestamoInteresConcedido
                    : refresListaDeCuentasPrestamoInteresRecibido
                }
                withCreateCuenta
              />
            )}
            {touched?.interes?.cuentaContableEmpresaId &&
              errors?.interes?.cuentaContableEmpresaId && (
                <small className='p-error p-d-block'>
                  {errors?.interes?.cuentaContableEmpresaId}
                </small>
              )}
          </div>
        </div>

        <div className='mb-3 input-group_container'>
          <div
            className={classNames("input_box", {
              disabled: !activeSwitch,
            })}
          >
            <label htmlFor='interes'>{t("prestamos.form.typeWhiteOff")}</label>
            <FormikDropdown
              options={TIPOS_AMORTIZACION_OPTIONS(t)}
              value={values.tipoImporteAmortizacion}
              onChange={(value: $TSMigrationFixMe) => handleChange(value)}
              placeholder={t("prestamos.form.placeholderTypeDocumento")}
              emptyFilterMessage={t("prestamos.form.emptyMsg")}
              emptyMessage={t("prestamos.form.emptyMsg")}
              fluid
              id='tipoImporteAmortizacion'
              name='tipoImporteAmortizacion'
              onBlur={handleBlur}
              disabled={!activeSwitch}
            />
          </div>
          <div
            className={classNames("input_box mb-3", {
              disabled: !activeSwitch,
            })}
          >
            <label>
              {values.tipoImporteAmortizacion
                ? `${
                    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
                    TIPO_PERIODO_AMORTIZACION(t)[values.tipoImporteAmortizacion]
                    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
                  } ${PERIODO_AMORTIZACION(t)[
                    values.periodoAmortizacion
                  ]?.toLowerCase()}`
                : ""}
            </label>
            <FormikInputNumber
              id='importeAmortizacion'
              name='importeAmortizacion'
              onBlur={handleBlur}
              disabled={!activeSwitch || !values.tipoImporteAmortizacion}
              minFractionDigits={2}
            />
          </div>
        </div>
      </div>
      <NewComisionBoard
        title={t("prestamos.form.newComisionLabel")}
        data={transformDataComisiones}
        modalTitle='comisión'
        className='mb-3'
        setFieldValue={setFieldValue}
        fieldKey='comisiones'
        values={values}
        tabSelected={tabSelected}
        contablesComisiones={
          tabSelected === PRESTAMOS_TYPE.CONCEDIDO
            ? cuentasContablesComisionAperturaPrestamoConcedido
            : cuentasContablesComisionAperturaPrestamoRecibido
        }
      />
      <CamposPersonalizadoBoard
        endpointSlice={CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE.prestamo}
        className='pt-3'
        camposPersonalizados={values?.camposPersonalizados}
      />
      <div className='mt-3 mb-3 input-group_container'>
        <div className='mb-3 cuentas-contables_select-container'>
          <label>{t("prestamos.form.cuentaConFinLabel")}</label>
          {!(tabSelected === PRESTAMOS_TYPE.CONCEDIDO
            ? cuentasContablesPrestamoConcedido?.length
            : cuentasContablesPrestamoRecibido?.length) ? (
            <span className='p-input-icon-left w-100'>
              <i className='pi pi-spin pi-spinner' />
              <InputText disabled />
            </span>
          ) : (
            <DropdownCuentasContablesConModal
              cuentasContablesOptions={
                tabSelected === PRESTAMOS_TYPE.CONCEDIDO
                  ? cuentasContablesPrestamoConcedido
                  : cuentasContablesPrestamoRecibido
              }
              dropdownValue={values?.cuentaContableEmpresaId}
              onChange={handleSelectCtaContable}
              withCreateCuenta
              listaDeCuentasBase={
                tabSelected === PRESTAMOS_TYPE.CONCEDIDO
                  ? cuentasContablesPrestamoConcedidoBase
                  : cuentasContablesPrestamoRecibidoBase
              }
              refreshFetchData={
                tabSelected === PRESTAMOS_TYPE.CONCEDIDO
                  ? refresListaDeCuentasPrestamoConcedido
                  : refresListaDeCuentasPrestamoRecibido
              }
            />
          )}
          {touched?.cuentaContableEmpresaId &&
            errors?.cuentaContableEmpresaId && (
              <small className='p-error p-d-block'>
                {errors?.cuentaContableEmpresaId}
              </small>
            )}
        </div>
      </div>
      <div className='tw-flex tw-justify-end tw-items-center tw-gap-3 tw-mt-4'>
        <ButtonERP
          type='button'
          onClick={() => hideModal()}
          customize={{
            type: "white",
            size: "md",
          }}
          label={`${t("prestamos.form.cancelButton")}`}
        />
        <ButtonERP
          type='submit'
          customize={{
            type: "primary",
            size: "md",
          }}
          label={
            isEditView
              ? `${t("prestamos.form.saveButton")}`
              : `${t("prestamos.form.createButton")}`
          }
          className='tw-w-25'
        />
      </div>

      {values.empresaContactoId && (
        <ModalAccountContactCuentaBancaria
          id={values.empresaContactoId}
          createOrEditModal={createOrEditModal}
          onHide={onHideCreateOrEditModal}
          contactosCuentaBancariaByIdRefetch={handleCreateCtaBancaria}
        />
      )}
      <Modal
        visible={showModalConfirmAmortizacion}
        onHide={() => setShowModalConfirmAmortizacion(false)}
        size='smallS'
      >
        <div className='d-flex justify-content-center w-100'>
          <div className='atention-icon-container d-flex justify-content-center align-items-center'>
            <FontAwesomeIcon
              icon={["fal", "triangle-exclamation"]}
              className='icon-warning'
            />
          </div>
        </div>
        <div className='mt-3 d-flex flex-column align-items-center w-100'>
          <h4 className='title confirm'>
            {t("prestamos.form.modal.confirmAmortLabel")}
          </h4>
          {handleChangeValueMessage(changeImporte, typeChange, t)}
        </div>
        <div className='departaments-modal__actions'>
          <Button
            className='w-50 text d-flex justify-content-center'
            // @ts-expect-error TS(2769): No overload matches this call.
            type='text'
            onClick={onCancelConfirmAmort}
          >
            {t("prestamos.form.modal.cancelButton")}
          </Button>
          <CustomButton
            className='ml-2 primary w-50'
            onClick={onConfirmSubmit}
          >
            {t("prestamos.form.modal.continueLabel")}
          </CustomButton>
        </div>
      </Modal>
    </form>
  )
}

export default PrestamoForm
